// Flash Deal Timer Functionality
// Shared by the PDP freebies surfaces (pdp-freebies-banner-with-popup and
// pdp-new-freebies-v1). Drives every .flash-deal-countdown /
// .flash-deal-countdown-popup on the page off one rolling target so the banner
// and the popup never disagree. Re-entrant: each run clears the intervals the
// previous run created.
(function () {
  const flashDealIntervals = [];
  
  function parseDateAsEST(dateString) {
    if (!dateString) return null;
    
    const parts = dateString.trim().split(' ');
    if (parts.length !== 2) return null;
    
    const datePart = parts[0].split('-');
    const timePart = parts[1].split(':');
    
    if (datePart.length !== 3 || timePart.length !== 2) return null;
    
    const year = parseInt(datePart[0], 10);
    const month = parseInt(datePart[1], 10) - 1;
    const day = parseInt(datePart[2], 10);
    const hours = parseInt(timePart[0], 10);
    const minutes = parseInt(timePart[1], 10);
    
    const estOffsetHours = 5;
    const utcDate = new Date(Date.UTC(year, month, day, hours + estOffsetHours, minutes, 0));
    
    return utcDate;
  }
  
  function updateFlashDealTimer() {
    // Clear any existing intervals before starting fresh — prevents duplicates
    flashDealIntervals.forEach(interval => clearInterval(interval));
    flashDealIntervals.length = 0;
    
    const countdownElements = document.querySelectorAll('.flash-deal-countdown, .flash-deal-countdown-popup');
    
    if (countdownElements.length === 0) return;
    
    const sharedRollingTimer = { targetDate: null };
    const firstRollingElement = Array.from(countdownElements).find(el => el.getAttribute('data-rolling-24h') === 'true');
    
    if (firstRollingElement) {
      const now = new Date();
      const storageKey = 'flashDealEndTime';
      let savedEndTime = localStorage.getItem(storageKey);
      
      if (savedEndTime) {
        const savedDate = new Date(parseInt(savedEndTime));
        if (savedDate > now) {
          sharedRollingTimer.targetDate = savedDate;
        } else {
          const randomHours = Math.floor(Math.random() * (23 - 9 + 1)) + 9;
          sharedRollingTimer.targetDate = new Date(now.getTime() + randomHours * 60 * 60 * 1000);
          localStorage.setItem(storageKey, sharedRollingTimer.targetDate.getTime().toString());
        }
      } else {
        const randomHours = Math.floor(Math.random() * (23 - 9 + 1)) + 9;
        sharedRollingTimer.targetDate = new Date(now.getTime() + randomHours * 60 * 60 * 1000);
        localStorage.setItem(storageKey, sharedRollingTimer.targetDate.getTime().toString());
      }
    }
    
    countdownElements.forEach(function(element) {
      const rolling24h = element.getAttribute('data-rolling-24h') === 'true';
      const endDateStr = element.getAttribute('data-end-date');
      
      let targetDate;
      if (rolling24h) {
        targetDate = sharedRollingTimer;
      } else if (endDateStr) {
        targetDate = parseDateAsEST(endDateStr);
        if (!targetDate) {
          element.textContent = '--:--:--';
          return;
        }
      } else {
        element.textContent = '--:--:--';
        return;
      }
      
      function updateTimer() {
        const now = new Date();
        const targetTime = rolling24h ? targetDate.targetDate.getTime() : targetDate.getTime();
        const diff = targetTime - now.getTime();
        
        if (diff <= 0) {
          if (rolling24h) {
            const randomHours = Math.floor(Math.random() * (23 - 9 + 1)) + 9;
            targetDate.targetDate = new Date(now.getTime() + randomHours * 60 * 60 * 1000);
            localStorage.setItem('flashDealEndTime', targetDate.targetDate.getTime().toString());
            updateTimer();
            return;
          } else {
            element.textContent = '00:00:00';
            return;
          }
        }
        
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        
        // Two units at most. Three ran long enough to wrap the subheader on a
        // narrow buy box, and the smallest unit is the least useful one at every
        // scale: with hours on the clock nobody is reading the seconds.
        const pad = (n) => String(n).padStart(2, '0');
        if (days > 0) {
          element.textContent = `${pad(days)}D ${pad(hours)}H`;
        } else if (hours > 0) {
          element.textContent = `${pad(hours)}H ${pad(minutes)}M`;
        } else {
          element.textContent = `${pad(minutes)}M ${pad(seconds)}S`;
        }
      }
      
      updateTimer();
      const intervalId = setInterval(updateTimer, 1000);
      flashDealIntervals.push(intervalId);
    });
  }

  window.updateFlashDealTimer = updateFlashDealTimer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFlashDealTimer);
  } else {
    updateFlashDealTimer();
  }
})();
